/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';
import HttpServiceNoToken from './HttpServiceNoToken';

export default {
    saveCookiePolicy(payload) {
        return HttpService.put(environment.API_COOKIE_PRIVACY_POLICY, payload);
    },
    searchCookiePolicy(dataTypeId) {
        return HttpService.get(
            environment.API_COOKIE_PRIVACY_POLICY +
                `?dataSubjectTypeIds=${dataTypeId}`
        );
    },
    getCookiePolicyDetail(policyId) {
        return HttpService.get(
            environment.API_COOKIE_PRIVACY_POLICY + `/${policyId}`
        );
    },
    getCookiePolicyDetailPublic(policyId) {
        return HttpServiceNoToken.get(
            environment.API_COOKIE_PRIVACY_POLICY_PUBLIC +
                `/publish-version/${policyId}`
        );
    },
    //History
    getHistories(params) {
        return HttpService.get(
            environment.API_COOKIE_PRIVACY_POLICY + `/history`,
            {
                params,
            }
        );
    },
    getHistoryDetail(params) {
        return HttpService.get(
            environment.API_COOKIE_PRIVACY_POLICY + `/history/detail`,
            {
                params,
            }
        );
    },
    deleteCookiePolicy(policyId) {
        return HttpService.delete(
            environment.API_COOKIE_PRIVACY_POLICY + `/${policyId}`
        );
    },
    rename(payload) {
        return HttpService.put(
            environment.API_COOKIE_PRIVACY_POLICY + '/rename',
            payload
        );
    },
    getPublishedVersion(id) {
        return HttpService.get(
            environment.API_COOKIE_PRIVACY_POLICY + `/publish-version/` + id
        );
    },
    getCookieDomain(domainId) {
        return HttpService.get(
            environment.API_WFSECURE + `/cookie/cookie-policy/${domainId}`
        );
    },
    getCookieDomainPublic(domainId) {
        return HttpService.get(
            environment.API_PUBLIC + `/cookie/cookie-policy/${domainId}`
        );
    },
};
